import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Textbox.styles';
const Textbox = React.forwardRef((props, ref) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Input, { ref: ref, ...props })));
});
Textbox.displayName = 'Textbox';
export default Textbox;
